import React, { useCallback, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState, FileType } from 'types';
import Collector from 'components/collector';
import api from 'api';
import './dashboard.scss';
;

function Dashboard() {
    const history = useNavigate();
    const dispatch = useDispatch();

    const params: any = useParams();
    const state = useSelector((state: RootState) => state);
    const [playing, setPlaying] = useState(false)
    const [files, setFiles] = useState<FileType[]>([]);
    const [file, setFile] = useState<FileType>();
    const [fileBytes, setFileBytes] = useState<any>();
    const [fileIndex, setFileIndex] = useState<number>(0);
    
    const getFiles = useCallback(async () => {
        await api.file.getToCollect()
        .then(data => {
            // console.log(data);
            setFiles(data);
        })
    }, [dispatch]);
    
    const getFileBytes = () => {
        api.file.getBytes(file?.Id || 0)
        .then(data => {
            // console.log(data);
            setFileBytes(data);
        })
    };

    const incFileIndex = () => {
        if (fileIndex < files.length -1){
            setFileIndex(fileIndex + 1);
            // console.log("files.length: ", files.length);
        }
        else {
            getFiles();
            setFileIndex(0);
        }
        // console.log("file index: ", fileIndex);
    }
    
    useEffect(() => {
        getFiles();
    }, [dispatch]);

    useEffect(() => {
        // console.log('files[fileIndex]: ', files[fileIndex]);
        setFile(files[fileIndex]);
    }, [files, fileIndex]);

    useEffect(() => {
        // console.log('file: ', file);
        if (file){
            getFileBytes();
        }
    }, [file]);

    return (
        <div id="dashboard" className="container">
            <div className='player-wrapper'>
                <ReactPlayer 
                    className='react-player'
                    url={'data:audio/wav; base64, ' + fileBytes}
                    width='100%'
                    height={'2rem'}
                    controls={true}
                    playing={playing}
                    config={{
                        file: {
                          forceAudio: true
                        }
                      }}
                />
            </div>
            <Collector fileId={file?.Id || 0} incFileIndex={incFileIndex}/>
        </div>
    )
}

export default Dashboard;
